/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandBackbone = createReactComponent("outline", "brand-backbone", "IconBrandBackbone", [["path", { "d": "M5 20l14 -8l-14 -8z", "key": "svg-0" }], ["path", { "d": "M19 20l-14 -8l14 -8z", "key": "svg-1" }]]);

export { IconBrandBackbone as default };
//# sourceMappingURL=IconBrandBackbone.mjs.map
